console.log("responsive-wrapper.js modifié");

(function () {

  const selectors = [
    "iframe[src*='vimeo']",
    "iframe[src*='videos.univ-grenoble-alpes.fr']",
    "iframe[src*='www.google.com/maps/']",
    "iframe[src*='www.openstreetmap.org']",
    "iframe[src*='www.instagram.com']",
    "iframe[src*='www.monecowatt.fr']",
    "iframe[src*='www.skaping.com']"
  ];

  document.querySelectorAll(selectors.join(",")).forEach(iframe => {
    if (iframe.parentElement.classList.contains('responsiveWrapper')) return;

    const wrapper = document.createElement("div");
    wrapper.className = "responsiveWrapper";

    // cas spécifique monecowatt
    if (iframe.src.includes("www.monecowatt.fr")) {
      wrapper.classList.add("responsiveWrapper--vertical-pan");
      console.log("monecowatt détecté");
    }

    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  });

})();